<template>
  <div>
    <va-modal
      v-model="showAddEntreprise"
      title="Ajouter une entreprise"
      max-width="1200px"
      v-on:ok="addEntreprise"
      v-on:cancel="closeModal"
      noEscDismiss
      noOutsideDismiss
      disabled
    >
      <div class="forcewidthae">
        <div class="'row row-inside pa-2">
          <h3>Entreprise base OPEF</h3>

          <va-input
            v-model="searchQueryOpef"
            placeholder="Entrez au moins 3 caractères pour rechercher"
            @input="onSearchOpefChange"
            clearable
          >
            <va-icon name="fa fa-search" slot="prepend" />
          </va-input>

          <va-select
            :disabled="entrepriseAfpfSelect !== '' || searchQueryOpef.length < 3"
            class="my-4"
            label="Selection de l'entreprise"
            key-by="identreprise"
            text-by="displayText"
            :options="listeEntreprise"
            placeholder="Sélectionnez une entreprise"
            v-model="entrepriseSelect"
          />
        </div>
        <div class="'row row-inside pa-2">
          <h3>Entreprise base AFPF</h3>

          <va-select
            :disabled="entrepriseSelect !== ''"
            class="my-4"
            label="Selection de l'entreprise"
            key-by="identreprise"
            text-by="nom"
            :options="listeEntrepriseAFPF"
            placeholder="Selection de l'entreprise"
            v-model="entrepriseAfpfSelect"
            searchable
          />
        </div>
      </div>
    </va-modal>
  </div>

</template>

<script>
import axios from "axios";

export default {
  name: 'AddEntreprise',
  props: ["value", "idformation"],
  data() {
    return {
      showAddEntreprise: false,
      listeEntreprise: [],
      entrepriseSelect: "",
      listeEntrepriseAFPF: [],
      entrepriseAfpfSelect: "",
      searchQueryOpef: "",
      searchTimeoutOpef: null,
    };
  },
  methods: {
    async addEntreprise() {
      if (this.entrepriseSelect === "" && this.entrepriseAfpfSelect === "") {
        this.launchToast("Pas d'entreprise sélectionnée");
        this.$emit("input", false);
        return;
      }

      if (!this.idformation) {
        this.launchToast("Formation invalide");
        this.$emit("input", false);
        return;
      }

      try {
        let entrepriseSelect = this.entrepriseSelect !== "" ? this.entrepriseSelect : this.entrepriseAfpfSelect;
        await axios.post("/api/afpf/add-entreprise-to-formation", {
          idformation: this.idformation,
          identreprise: entrepriseSelect.identreprise,
        });
        this.$emit("idEntreprise", entrepriseSelect.identreprise);
        this.entrepriseSelect = "";
        this.entrepriseAfpfSelect = "";
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors de l'ajout de l'entreprise");
      }

      this.$emit("input", false);
    },
    closeModal() {
      this.entrepriseSelect = "";
      this.entrepriseAfpfSelect = "";
      this.$emit("input", false);
    },
    async searchEntreprises(query) {
      if (query.length < 3) {
        this.listeEntreprise = [];
        return;
      }
      try {
        let res = await axios.get(`api/entreprises/find-entreprise`, {
          params: { search: query }
        });
        // Add displayText field to each option
        this.listeEntreprise = res.data.map(entreprise => ({
          ...entreprise,
          displayText: `${entreprise.nom} (${entreprise.siret}; ${entreprise.code_postal}  ${entreprise.ville}; ${entreprise.gerant})`
        }));
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors de la recherche");
      }
    },
    onSearchOpefChange(query) {
      // Clear existing timeout
      if (this.searchTimeoutOpef) {
        clearTimeout(this.searchTimeoutOpef);
      }
      
      // Set new timeout to debounce search requests
      this.searchTimeoutOpef = setTimeout(() => {
        this.searchEntreprises(query);
      }, 300);
    },
    getListEntreprises() {
      // For AFPF, we still load on modal open
      this.getListEntreprisesAFPF();
    },
    async getListEntreprisesAFPF() {
      try {
        let res2 = await axios.get("/api/afpf/liste-entreprises-selection-afpf");
        this.listeEntrepriseAFPF = res2.data.listeEntreprise;
        console.log("listeEntrepriseAFPF", this.listeEntrepriseAFPF);
        this.isready = true;
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors du chargement");
      }
    },
    launchToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
  mounted() {
    this.showAddEntreprise = this.value;
  },
  watch: {
    value() {
      // Parent property changed; update internal variables
      this.showAddEntreprise = this.value;
      //  this.resetValues();
      if (this.value) {
        this.getListEntreprises();
      }
    }
  }
}
</script>

<style scoped>
.forcewidthae {
  width: 20vw;
  height: 40vh;
  overflow: auto;
}
</style>